import React from 'react';
import { withRouter } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import PKButton from "components/Button/Button";
import Container from 'react-bootstrap/Container';
//import { Badge, ButtonGroup, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
//import Form from 'react-bootstrap/Form';
//import NewVenue from 'components/AddNewVenue/AddNewVenue';
//import NewVenueV2 from 'components/AddNewVenue/AddNewVenueV2';
import axios from 'axios';

import ReactTooltip from 'react-tooltip';

//import { BroadcastChannel } from 'broadcast-channel';

import { CSVLink } from "react-csv";
// , CSVDownload

//import LeafCard from 'components/Leaves/LeafCard';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import { org_friendly_url, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import '../style.css';
//import Button from "components/Button/Button";
//import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { local_routes } from 'utils/Routes';
//import { NavLink } from 'react-router-dom';
//import { GoogleApiWrapper } from 'google-maps-react';
//let imgTempArr = [];

import Table from "react-bootstrap/Table";
import TableHeader from "components/Table/TableHeader";
import UserTable from "components/UserTable/UserTable";

import UserContext from 'store/UserContext';


class Registration extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            zoom_registrants_array: [],
            loading: true,
            button_loading: false,
            message: '',
            email_registrant_data: []
        };

        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }

        this.user_table_header_display = { 'Name': "", 'Email': "", 'View': "", 'Approve/Deny': "" };
        
        this.togglebutton_options = [
            {
                value: 'approved',
                verb_label: 'Approve',
                adj_label: 'Approved',
                zoom_status_action: 'approve'
            },
            {
                value: 'denied',
                verb_label: 'Deny',
                adj_label: 'Denied',
                zoom_status_action: 'cancel'
            }
        ];
        
        this.csvLink = React.createRef();
        
        this.email_registrant_headers = [
            { label: "status", key: "status" },  
            { label: "email", key: "email" },
        ];
        
        this.email_registrant_data = [];
    }
    
    componentDidMount = async function () {
        if (!this.props.event_uuid) {
            console.error("BAD! No event_uuid");
            return;
        }
        
        if (!this.props.source_info.entity_type || !this.props.source_info.entity_uuid) {
            console.error("BAD! No source_info",this.props.source_info);
            return;
        }
        
        await this.APICalls();
    }

    APICalls = async function (config = {}) {
        let new_state = {...this.state};

        let api_promises = [];
        
        let params = {
            filter_obj: {
                zoom_registrant_object: {
                    exists: true
                }
            }
        };
        api_promises.push(axios.get(`${apiUrl}events/${this.props.event_info.entity_uuid}/audience`, { params, ...myHeaders_Auth_With_Cache_Control}));
        
        let [event_users_response] = await Promise.all(api_promises);
        
        //console.log("YO",event_users_response.data);

        new_state.zoom_registrants_array = event_users_response.data;
        
        new_state.loading = false;
        
        this.setState( new_state );
    }

    onApproveOrCancelRegistrant = async (user_info,toggle_value) => {
        console.log("onApproveRegistrant");
        let zoom_status_action = 'deny';
        if (toggle_value === 'approved') {
            zoom_status_action = 'approve';
        }
        let patch_obj = {
            entity_uuid: user_info.entity_uuid,
            zoom_status_action
        };
        await axios.post(`${apiUrl}events/${this.props.event_info.entity_uuid}/updateZoomRegistrantStatus`, patch_obj);
    }
    
    onFinish = () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }

    finish = () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }

    downloadEmailAddresses = async () => {
        console.log("downloadEmailAddresses");
        this.setState({button_loading: true});
        let download_email_address_response = await axios.post(`${apiUrl}events/${this.props.event_info.entity_uuid}/downloadRegistrantEmails`);
        //console.log("YO",download_email_address_response.data);
        this.email_registrant_data = download_email_address_response.data;
        this.setState({
            email_registrant_data: download_email_address_response.data,
        }, () => {setTimeout(() => {
            this.csvLink.current.link.click()},1000);
            this.setState({button_loading: false});
        });
    }
    
    render() {
        if (this.state.loading) {
            return (
                <div className="spinner-pos">
                    <FullPageSpinner />
                </div>
            );
        }

        return (
            <Container>
                <Row className="justify-content-end">
                
                    <Button
                        variant="pkprimary"
                        size="sm"
                        onClick={this.downloadEmailAddresses}
                        disabled={this.state.button_loading}
                    >
                        Download Email Addresses (.csv)
                    </Button>

                    <CSVLink
                        data={this.state.email_registrant_data}
                        headers={this.email_registrant_headers}
                        filename={"event_registrant_data_"+Math.floor(new Date().getTime() / 1000)+".csv"}
                        ref={this.csvLink}
                        target="_blank"
                    />
                        
                </Row>
                <Row className="presenters-info pkListContainer eventCreation">
                
                        <Row style={{ marginTop: "0px" }} className="">
                            <Col xs={12}>
    
                                <div className="table-boby">
                                    <Table variant={this.context.theme} responsive={true}>
                                        <tbody>
                                            {/* Pending section header*/}
                                            <TableHeader
                                                headerType="Users"
                                                tableHeader={this.user_table_header_display}
                                                listLength={this.state.zoom_registrants_array.length}
                                            />
        
                                            {this.state.zoom_registrants_array.map((item, i) => {
                                                return (
                                                    <UserTable
                                                        key={i}
                                                        userData={item}
                                                        workspace_base_url={this.workspace_base_url}
                                                        onToggleChange={this.onApproveOrCancelRegistrant}
                                                        togglebutton_options={this.togglebutton_options}
                                                        toggle_value={item.xref_data.zoom_registrant_status}
                                                        //OnEditUser={this.showEditUser}
                                                        //OnRemoveUser={this.removeUserFromWorkspace}
                                                        //OnChangeDropdown={this.updateUserAccessLevel}
                                                        //dropdown_options={this.user_table_access_level_options}
                                                    />
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </Col>
                        </Row>
                    
                    <div className="form-group btn-venueposition">
                        <React.Fragment>
                            <Button
                                size="sm"
                                onClick={this.finish}
                                variant="secondary"
                            >
                                Finish
                            </Button>
                        </React.Fragment>
                    </div>
                    
        
                
                </Row>
            <ReactTooltip/>
            </Container>
        );
    }
}

export default withRouter(Registration);